import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { fs } from '../utils/a11y.js';

export function UpdateAlert({ show, reloadApp, onClose }) {
  const DURATION = 30; // Seconds.
  const [elapsedTime, setElapsedTime] = useState(0);
  const [_interval, _setInterval] = useState(undefined);

  useEffect(() => {
    if (show) {
      _setInterval(
        setInterval(() => {
          setElapsedTime((et) => et + 1);
        }, 1000)
      );
    } else {
      handleClear();
    }
    return () => {
      handleClear();
    };
  }, [show]);

  useEffect(() => {
    if (elapsedTime > DURATION && reloadApp) reloadApp();
  }, [elapsedTime]);

  const handleClear = () => {
    if (_interval) clearInterval(_interval);
    setInterval(undefined);
    setElapsedTime(0);
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  const remainingTime = DURATION - elapsedTime;
  const progress = Math.round(100 - ((elapsedTime / DURATION) * 100));

  const updateAlertStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 9999,
    width: '100%',
    height: 'auto',
    padding: '20px',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--update-alert-background)'
  };

  const labelStyle = {
    color: 'var(--color-text-primary)',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 'bold',
    fontSize: fs(21),
    textAlign: 'center',
    width: '100%',
  };

  const cancelButtonContainerStyle = {
    margin: '20px 0px 0px 0px'
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          style={updateAlertStyle}
          initial={{ y: '-100%' }}
          animate={{ y: 0 }}
          exit={{ y: '-100%' }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <p style={labelStyle}>Existe una actualización disponible, este Tótem se reiniciará en {remainingTime > 0 ? remainingTime : 0} segundo(s)</p>
          <div style={cancelButtonContainerStyle}>
            <motion.button
              onClick={handleClose}
              className='cursor-pointer btn w-auto h-auto shadow-lg btn-primary p-10'
              style={{ opacity: 1 }}
              whileTap={{ scale: 0.8 }}
              whileHover={{ scale: 1.03 }}
              transition={{
                boxShadow: { delay: 0, duration: 2, repeat: Infinity, ease: 'linear' },
                scale: { duration: 0.2, ease: 'easeOut' }
              }}
              animate={{ boxShadow: ['0px 0px 30px 0px var(--color-primary-glow)', '0px 0px 30px 15px var(--color-primary-glow)', '0px 0px 30px 0px var(--color-primary-glow)'] }}
            >
              <span className="fs-25 lh-38 main-font-bold">Cancelar</span>
            </motion.button>
          </div>
          <div className='update-alert-progress-bar'>
            <div className='update-alert-progress-bar-fill' style={{ width: `${progress > 0 ? progress : 0}%` }} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}